<!--<app-navbar></app-navbar>

<div class="main-container d-flex">

&lt;!&ndash;  <app-sidebar></app-sidebar>&ndash;&gt;

  <div class="content flex-grow-1">

    <router-outlet></router-outlet>
  </div>
</div>-->
<pm-loader-component></pm-loader-component>
<app-navbar></app-navbar>
